import React, { useMemo } from 'react'

import { LntSteps } from '@app/components/base'

import { LogTitle } from './LogTitle'

import styles from './styles.module.scss'

import type { LntStep } from '@app/components/base/Steps/types'
import type { LogItem, ViewingLogsProps } from './types'

const logsToStepAdapter = (logs: LogItem[]): LntStep[] =>
  logs.map<LntStep>(logItem => {
    const { key, title: titleText, dateTime, ...step } = logItem

    const title = (
      <LogTitle
        key={ key }
        log={ {
          title: titleText,
          dateTime
        } }
      />
    )

    return {
      title,
      ...step
    }
  })

export const ViewingLogs: React.FC<ViewingLogsProps> = ({ logs }) => {
  const items: LntStep[] = useMemo(() => logsToStepAdapter(logs ?? []), [logs])

  return (
    <div className={ styles.viewingLogs }>
      <LntSteps
        progressDot
        direction='vertical'
        current={ items.length - 1 }
        items={ items }
      />
    </div>
  )
}
